module.exports = __webpack_public_path__ + "fonts/BentonSansBBVA-Book.ffa020f7.eot";